import { render, staticRenderFns } from "./PersonasTabFoto.vue?vue&type=template&id=b6c33954"
import script from "./PersonasTabFoto.vue?vue&type=script&lang=js"
export * from "./PersonasTabFoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports